import React from 'react'
import { Navigate, useLocation } from 'react-router'
import { useAuth } from '@/common/hooks/useAuth.ts'
import { routes } from '@/utils/routes.ts'

export const PrivateRoutes: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const location = useLocation()
  const { user, permissions } = useAuth()

  // check on every render
  if (!user || user.exp * 1000 <= Date.now() || !permissions) {
    return <Navigate to={routes.login} state={{ from: location.pathname }} />
  }

  return children
}